import React, { useEffect, useState } from 'react';
import './Aquaa.css';
import { useSelector } from 'react-redux';
import AdminBreadcrumb from '../../components/Administration/General/Admin-breadcrumb';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { OnboardSelect } from '../../components/Onboard/OnboardComponents/Dropdown/Select';
import Filter_Icon from './../../assets/images/Filter_Icon.png';
import { getAquaaNonASDAccountsData, getAquaaNonASDAgentsData, getAquaaNonASDChannelsData, getAquaaNonASDLanguagesData, getAquaaNonASDLocationsData, getNonASDEvaluationFormData } from '../../actions/Applications/aquaa.action';
import { saveEvaluationData } from './../../actions/Applications/aquaa.action';


const AquaaNonASD = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const aquaaNonASDAccounts = useSelector((state) => state.aquaaReducer.aquaaNonASDAccounts);
    const aquaaNonASDChannels = useSelector((state) => state.aquaaReducer.aquaaNonASDChannels);
    const aquaaNonASDLocations = useSelector((state) => state.aquaaReducer.aquaaNonASDLocations);
    const aquaaNonASDLanguages = useSelector((state) => state.aquaaReducer.aquaaNonASDLanguages);
    const aquaaNonASDAgents = useSelector((state) => state.aquaaReducer.aquaaNonASDAgents);
    const nonASDEvaluationFormData = useSelector((state) => state.aquaaReducer.nonASDEvaluationFormData);


console.log('nonASDEvaluationFormData',nonASDEvaluationFormData)


    const [selectedAccount, setSelectedAccount] = useState();
    const [selectedChannel, setSelectedChannel] = useState();
    const [selectedLocation, setSelectedLocation] = useState();
    const [selectedLanguage, setSelectedLanguage] = useState();
    const [selectedAgent, setSelectedAgent] = useState();
    const [isRefreshClicked, setIsRefreshedClicked] = useState(false); 
      const [isEvaluationFetched, setIsEvaluationFetched] = useState(false);

     useEffect(()=> {
        dispatch(getAquaaNonASDAccountsData());
      }, [dispatch]);

 const addValueToAccount = (name, value) => {
    if (value !== 'Select') {
        const selectedAccountData = aquaaNonASDAccounts.find(account => account.Account === value);
        
        if (selectedAccountData) {
            const newFormData = { 
                ...selectedAccount,  
                ...selectedAccountData,  
            };
            setSelectedAccount(newFormData);
        }
    }
};

console.log('selectedChannel',selectedChannel)

      useEffect(()=>{
        if(selectedAccount && selectedLocation){
            dispatch(getAquaaNonASDChannelsData(selectedAccount.AccountID,selectedLocation));
        }
      },[dispatch,selectedAccount,selectedLocation])

      const updateSelectedChannelWithObject = (selectedValue, channels) => {
        const selectedObject = channels.find(channel => channel.ContactTypeForm === selectedValue);
      
        if (selectedObject) {
          setSelectedChannel(selectedObject); 
        } else {
          console.error('Selected value does not match any available channels.');
        }
      };

      useEffect(()=>{
        if(selectedAccount){
            dispatch(getAquaaNonASDAgentsData(selectedAccount.AccountID));

        }
      },[dispatch,selectedAccount])

      useEffect(()=>{
    if(selectedAccount){
            dispatch(getAquaaNonASDLocationsData(selectedAccount.AccountID));

        }
      },[dispatch,selectedAccount])
     

      useEffect(()=>{
        if(selectedAccount && selectedLocation){
            dispatch(getAquaaNonASDLanguagesData(selectedAccount.AccountID, selectedLocation));
        }
      },[dispatch,selectedAccount,selectedLocation])

       useEffect(()=>{
          if (nonASDEvaluationFormData && Array.isArray(nonASDEvaluationFormData) && nonASDEvaluationFormData.length > 0 
        && isEvaluationFetched) {

            if(selectedAccount.Account === nonASDEvaluationFormData?.[0]?.AccountDetails?.[0]?.Account && selectedChannel.Channel === nonASDEvaluationFormData?.[0]?.AccountDetails?.[0]?.Channel
                && selectedLocation === nonASDEvaluationFormData?.[0]?.AccountDetails?.[0]?.Site && selectedAgent === nonASDEvaluationFormData?.[0]?.AccountDetails?.[0]?.Agent &&
                selectedLanguage === nonASDEvaluationFormData?.[0]?.AccountDetails?.[0]?.Language

            )
            {
            dispatch(saveEvaluationData(nonASDEvaluationFormData))
            history.push('/evaluationform')
            }
            
          }
        },[nonASDEvaluationFormData,dispatch,history,isEvaluationFetched,selectedAccount,selectedChannel,selectedLocation,selectedAgent,selectedLanguage])



       


    return (
        <div>
            <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={()=>history.push('/aquaaapplications')} label2='AQuAA' isActive3={false} label3='AQuAA - Non ASD' />

            <section className='App_Layout'>
                <main className='Title_bar'> <div className='Applications_Title'> AQuAA - Non ASD </div>
                    <div className='btn_adduser' onClick={() => { history.push('/savedevaluations') }}>Manage</div></main>
            </section>
            <section className='Filter_aquaa'>
                <main className='aquaa_filter_img'>
                    <img src={Filter_Icon} alt='' style={{ padding: '20px', paddingTop: '70px', paddingLeft: '30px' }} />
                </main>
                <div className='aquaaFilterAlignment'>
                    <main className='Aquaa_dropdown'>
                        <label HtmlFor='account'>Account</label>
                        <OnboardSelect data={aquaaNonASDAccounts} name='accountName' value='Account' id='RoleId' marginTop='10px'
                            editValue='' addValueToQueue={addValueToAccount} refresh={isRefreshClicked} />
                    </main>
                    <main className='Aquaa_dropdown'>
                        <label HtmlFor='location'>Location</label>
                        <OnboardSelect data={aquaaNonASDLocations} name='Region' value='location' id='Id' marginTop='10px'
                            editValue='' addValueToQueue={(name, value) => { setSelectedLocation(value); setIsRefreshedClicked(false) }} refresh={isRefreshClicked} />
                    </main>
                    <main className='Aquaa_dropdown'>
                        <label HtmlFor='channel'>Evaluation Form</label>
                        <OnboardSelect data={aquaaNonASDChannels} name='evaluationform' value='ContactTypeForm' id='Id' marginTop='10px'
                            editValue='' addValueToQueue={(name, selectedValue) => {
          updateSelectedChannelWithObject(selectedValue, aquaaNonASDChannels);
          setIsRefreshedClicked(false); 
        }} refresh={isRefreshClicked} />
                    </main>
                    
                     <main className='Aquaa_dropdown'>
                        <label HtmlFor='agent'>Agent</label>
                        <OnboardSelect data={aquaaNonASDAgents} name='email' value='agent' id='Id' marginTop='10px'
                            editValue='' addValueToQueue={(name, value) => { setSelectedAgent(value); setIsRefreshedClicked(false) }} refresh={isRefreshClicked} />
                    </main>
                    <main className='Aquaa_dropdown'>
                        <label HtmlFor='language'>Language</label>
                        <OnboardSelect data={aquaaNonASDLanguages} name='Servicedesk' value='language' id='SiteId' marginTop='10px'
                            editValue='' addValueToQueue={(name, value) => { setSelectedLanguage(value); setIsRefreshedClicked(false) }} refresh={isRefreshClicked} />
                    </main>
                   

                   
                    <button className='btn_adduser' onClick={() => {
             dispatch(getNonASDEvaluationFormData(selectedAccount.AccountID, selectedAgent, selectedChannel.Channel, selectedLanguage, selectedLocation,selectedChannel.ContactTypeID));

            setIsEvaluationFetched(true)
          }}>EVALUATE</button>
                </div>
            </section>
        </div>
    )
}

export default AquaaNonASD